<template>
  <div class="common-blue-contain">
    <transition name="moveUp">
      <div v-show="showHelmetTable" class="box-line">
        <!-- 导出 + 收起 -->
        <div class="fold">
          <span @click="handleShowHelmetTable">
            {{ $t('collapseData') }}
          </span>
        </div>
        <el-table :data="tableData" class="tableContainer" size="mini" @sort-change="sortChange">
          <!-- 列表数据 -->
          <el-table-column type="index" :label="$t('SerialNo')" width="80" align="center">
            <template scope="scope">
              <span>{{ (queryParam.pageNum - 1) * queryParam.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('user')" width="120" show-overflow-tooltip sortable="userName" :sort-orders="['ascending', 'descending']">
            <template scope="scope">
              <span class="cursor" @click="handleNameClick(scope.row)">{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceName"
            :label="$t('equipmentNo')"
            width="180"
            show-overflow-tooltip
            :sort-orders="['ascending', 'descending']"
            sortable="deviceName"
          ></el-table-column>
          <el-table-column
            prop="ouName"
            :label="$t('Organization')"
            min-width="200"
            show-overflow-tooltip
            :sort-orders="['ascending', 'descending']"
            sortable="ouName"
          ></el-table-column>
          <el-table-column :label="$t('state')" width="80" show-overflow-tooltip sortable="onlineStatus" :sort-orders="['ascending', 'descending']">
            <template slot-scope="scope">
              <span :class="scope.row.onlineStatus === 1 ? 'online' : 'offline'">{{
                $t(scope.row.onlineStatus === 1 ? 'onLine' : 'offLine')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="simNo" :label="$t('cardNumber')" width="190" show-overflow-tooltip></el-table-column>
          <el-table-column prop="volume" :label="$t('monthFlow')" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('Power')" width="70" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.battery">{{ scope.row.battery | toFixed2 }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="offlineTime" :label="$t('Offlineduration')" width="160"></el-table-column>
          <el-table-column prop="locationTime" :label="$t('positioningTime')" width="160"></el-table-column>
          <el-table-column
            prop="address"
            :label="$t('geographicalPosition')"
            min-width="160"
            align="left"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="$t('operationh')" width="90" align="center">
            <template slot-scope="scope">
              <!-- 当有用户才能进行设备换绑 -->
              <span v-if="scope.row.userId" class="editClick" @click="handleBindClick(scope.row)">{{
                $t('rebinding')
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <button type="button" class="refresh" @click="queryList">{{ $t('refresh') }}</button>
          <button type="button" class="export" @click="handleExportClick">{{ $t('exportData') }}</button>
          <!-- 分页组件 -->
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParam.pageNum"
            :page-size="queryParam.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalData"
          >
          </el-pagination>
        </div>
      </div>
    </transition>
    <transition name="moveUp">
      <div v-show="!showHelmetTable">
        <!-- 展开 -->
        <!-- <div class="unfold">
          <span @click="showHelmetTable = true">
            {{ $t('openS') }}{{ $t('viewData') }}
            <img src="../../../icon/monitor/index/unfold.png" alt="unfold" />
          </span>
        </div> -->
      </div>
    </transition>
    <!--新增、编辑设备窗口-->
    <el-dialog
      class="helmetDialogMax"
      :title="$t('reboundEquipment')"
      :visible.sync="showBindDialog"
      :append-to-body="false"
      :close-on-click-modal="false"
    >
      <div class="common-blue-contain">
        <el-form ref="form" :model="bindForm" :rules="rules" label-width="110px">
          <el-form-item :label="$t('user')">
            <el-input v-model="bindForm.userName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="ouSelect"
              v-model="ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              @change="changeOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="ouTree"
                  node-key="id"
                  highlight-current
                  :expand-on-click-node="false"
                  :data="ouList"
                  :props="defaultProps"
                  @node-click="selectOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('bindingDeviceNo')" prop="deviceId">
            <el-select
              v-model="bindForm.deviceId"
              filterable
              clearable
              :placeholder="$t('selectBinding')"
              :popper-append-to-body="false"
            >
              <el-option v-for="item of unBindList" :value="item.id" :label="item.serialNumber" :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="alert-tip">
            {{ $t('onfirmWhetherVideo') }}
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindHelmet()">{{ $t('determine') }}</el-button>
        <el-button @click="showBindDialog = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { unBindDeviceList, deviceUserBind, findUserDevicePage, findUserDeviceExport } from '@/api/helmetManage'
import { getOus } from '@/api/UserList'
import { downloadBlobExcel } from '@/util/common'
import { success } from '@/api/common'
export default {
  name: 'HelmetList',
  props: {
    userTreeQueryParam: {
      type: Object,
      default: () => {
        return {
          onlineStatus: null,
          userName: null,
        }
      },
    },
  },
  data() {
    return {
      // 查询表单form字段
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      // 列表数据
      tableData: [],
      // 数据总条数
      totalData: 0,
      // 展示换绑设备编辑弹窗
      showBindDialog: false,
      // 未绑定设备
      unBindList: [],
      // 当前绑定设备编辑表单
      bindForm: {
        deviceId: null,
        userId: null,
        userName: null,
      },
      // 当前选择机构
      ouName: '',
      // 机构树数据
      ouList: [],
      // 机构树下拉框格式
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      // 表单校验规则
      rules: {
        deviceId: [{ required: true, message: this.$t('bindingDeviceNumber'), trigger: 'blur' }],
      },
      userTreeQuery: {
        // 默认查询在线 + 离线
        statusList: '0,1',
        userName: null,
      },
    }
  },
  computed: {
    showHelmetTable() {
      return this.$store.state.showHelmetTable
    },
    userQuery() {
      return this.$store.state.userTreeQuery
    },
  },
  methods: {
    // 点击表头排序
    sortChange(column, prop, order) {
      console.log(column, prop, order)
      this.queryParam.sortColName = !column.order ? null : column.column.sortable
      this.queryParam.useAsc = column.order === 'descending' ? 0 : 1
      this.queryParam.pageNum = 1
      this.queryList()
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 列表数据查询
    queryList() {
      // 增加防抖处理，防止接口频繁查询
      if (this.queryListInterval) {
        clearTimeout(this.queryListInterval)
      }
      this.tableData = []
      this.queryListInterval = setTimeout(() => {
        let param = Object.assign(this.queryParam, this.userTreeQuery)
        findUserDevicePage(param).then(res => {
          if (res.data.list) {
            this.totalData = res.data.total
            this.tableData = res.data.list
          }
        })
      }, 400)
    },
    handleExportClick() {
      findUserDeviceExport(this.userTreeQuery).then(res => {
        downloadBlobExcel(res, this.$t('serEquipmentDetails') + '.xls')
      })
    },
    // 点击列表绑定按钮
    handleBindClick(row) {
      // 查询可绑定设备列表
      unBindDeviceList({ ouId: row.ouId }).then(res => {
        this.unBindList = res.data
        this.bindForm = {
          userId: row.userId,
          userName: row.userName,
          deviceId: null,
        }
        this.ouName = row.simpleOuName
        this.$nextTick(() => {
          this.$refs.ouTree.setCurrentKey(row.ouId)
        })
        if (this.$refs['form']) {
          this.$refs['form'].resetFields()
        }
        this.showBindDialog = true
      })
    },
    // 换绑设备
    bindHelmet() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          deviceUserBind(this.bindForm).then(res => {
            if (res.state === 0) {
              success(this.$t('deviceSuccessfully'))
              this.queryList()
              this.showBindDialog = false
            }
          })
        }
      })
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 选中机构，过滤用户
    selectOu(data) {
      this.ouName = data.name
      // 查询可绑定设备列表
      unBindDeviceList({ ouId: data.id }).then(res => {
        this.unBindList = res.data
      })
      this.bindForm.deviceId = null
      this.$refs.ouSelect.blur()
    },
    // 清空机构，过滤用户
    changeOu(data) {
      if (!data) {
        this.bindForm.deviceId = null
        this.$nextTick(() => {
          this.$refs.ouTree.setCurrentKey(null)
        })
        // 查询可绑定设备列表
        unBindDeviceList({ ouId: null }).then(res => {
          this.unBindList = res.data
        })
      }
    },
    // 点击切换每页条数
    handleSizeChange(val) {
      this.queryParam.pageSize = val
      this.queryList()
    },
    // 点击切换页数
    handleCurrentChange(val) {
      this.queryParam.pageNum = val
      this.queryList()
    },
    handleNameClick(row) {
      this.$emit('choosePointOpen', row.userId)
    },
    handleShowHelmetTable() {
      this.$store.commit('handleshowHelmetTable', false)
    },
  },
  mounted() {
    this.getOusTree()
    this.queryList()
  },
  watch: {
    // 监听查询条件 改变时进行一次查询
    userTreeQueryParam: {
      handler: function() {
        // 当切换查询条件时,页号重置为1，防止查不出数据
        this.queryParam.pageNum = 1
        // 增加防抖处理，防止接口频繁查询
        if (this.interval) {
          clearTimeout(this.interval)
        }
        this.interval = setTimeout(() => {
          this.queryList()
        }, 400)
      },
      deep: true,
    },
    // 监听结构树查询条件 改变时进行一次查询，在线/不在线、用户查询等
    userQuery: {
      handler: function(val) {
        console.log(val, '在线/不在线')
        this.userTreeQuery = val
        // 当切换查询条件时，页号重置为1，防止查不出数据
        this.queryParam.pageNum = 1
        // 增加防抖处理，防止接口频繁查询
        if (this.interval) {
          clearTimeout(this.interval)
        }
        this.interval = setTimeout(() => {
          this.queryList()
        }, 400)
      },
      deep: true,
    },
    showHelmetTable: {
      handler: function(val) {
        console.log(val)
        if (!val) {
          this.$store.commit('handleshowHelmetTable', false)
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.box-line {
  position: absolute;
  width: 100%;
  height: 280px;
  padding: 5px;
  background: #fff;
  bottom: 0px;
  z-index: 1;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;

  .fold {
    position: absolute;
    left: 6px;
    bottom: 4px;
    width: 60px;
    height: 24px;
    line-height: 24px;
    margin: auto;
    border: 1px solid #d1dae7;
    text-align: center;
    z-index: 1;
    padding: 0 5px;

    span {
      color: #0565de;
      cursor: pointer;
      font-weight: bold;
    }
  }

  .tableContainer {
    height: 238px !important;
    min-height: 238px;
    border: 1px solid #ccc;
    overflow: auto;
    .el-table__row {
      span {
        font-size: 12px;
      }
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    align-content: center;
    height: 30px;
    box-sizing: border-box;
    position: fixed;
    bottom: 32px;
    right: 20px;

    button {
      height: 21px;
      font-size: 13px;
      background: #0565de;
      border-radius: 2px;
      color: #ffffff;
      cursor: pointer;
      margin-top: 4px;
      margin-right: 10px;
      padding: 0 4px;

      &:hover {
        background: #66b1ff;
      }
    }

    .pagination {
      height: 22px;
    }
  }
}

.unfold {
  position: absolute;
  width: 120px;
  height: 30px;
  line-height: 30px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: #eff1f4;
  border: 1px solid #dcdfe6;
  border-bottom: none;
  border-radius: 4px 4px 0px 0px;
  text-align: center;
  z-index: 1;

  span {
    color: #0565de;
    cursor: pointer;
    font-weight: bold;
  }
}

.online {
  color: var(--mainMonitor-online-color);
}

.offline {
  color: var(--mainMonitor-offline-color);
}
.el-pagination {
  margin-top: 0px;
}
@media screen and (max-height: 1080px) {
  ::v-deep .el-table {
    td,
    th {
      padding: 12px 0 !important;
    }
  }
}

// 深色模式样式覆盖
.theme-dark {
  .box-line {
    border-color: #0057a8;
    background: #011a59;

    .fold {
      border-color: #00e4ff;
      background: #001143;

      span {
        color: #00e4ff;
      }
    }
    .footer {
      button {
        background: #00dfff;
        color: #0036ca;

        &:hover {
          background: #3a8ee6;
        }
      }
      .pagination {
        >>> .el-input__inner {
          background: #000 !important;
        }
      }
    }
    .tableContainer {
      border: 1px solid #0057a8;
    }
  }

  .unfold {
    background: #011a59;
    border-color: #0057a8;

    span {
      color: #fefefe;
    }
  }
}
</style>
